import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../App'
import HeaderHome from '../../../components.js/serveur/home/HeaderHome'
import Spinner from '../../../components.js/elements/Spinner'
import useFirebase from './../../../firebase/useFirebase'
import ButtonsHome from '../../../components.js/serveur/home/ButtonsHome'

const Home = () => {
    const { user } = useContext(AppContext)
    const { readData, readDataMessagesChat, profil, count, messagesChat } = useFirebase()
    const [montage, setMontage] = useState(true)
    let navigate = useNavigate()

    useEffect(() => {
        readData(user.uid)
        readDataMessagesChat(user.uid) 
        window.scrollTo(0, 0)
        setMontage(false)
        console.log('Home useEffect',) 
    },[count])

    if (montage) return <Spinner />

 
    return (
        <div className='container-fluid'>
            <HeaderHome
                profil={profil}
                user={user}
            />

            {/* BOUTTONS */}
            <ButtonsHome 
                profil={profil}
                messagesChat={messagesChat}
            />

            {/* ESPACE ADMINISTRATEUR */}
            {user.uid === 'Ui9uUy6IRsXMUk5AgznTDvTeErF3' && 
                <div className='text-center mt-5'>
                    <div>espace administrateur</div>
                    <button className='btn btn-outline-dark mt-3' onClick={() => navigate('/administrateur')}>accès</button>
                </div>
            }
            <div style={{ height:400 }}></div> 
        </div>
    )
}

export default Home

/*
/*    /index.html   200
*/


















